import React, { useState } from "react";
import FAQItem from "./FAQItem";
import ContactUs from "../contact-Us/ContactUs";
import { useInView } from "react-intersection-observer";
import { useBreakpoint } from "../../pages/Home/Home";

const faqs = [
  {
    question: "Will Zero Typing work in the apps I already use?",
    answer:
      "Yes, Zero Typing works across almost every application that accepts text input. Whether you're replying to emails, writing in Google Docs, messaging in WhatsApp, or updating CRM notes, if you can type into it, you can speak into it. No special integrations are needed, just place your cursor and start talking.",
  },
  {
    question: "Can I use Zero Typing in my own language?",
    answer:
      "Yes, you can dictate in many different languages. However, translation currently works only into English. This makes it ideal for users who speak another language but need to produce clean English text quickly. More translation directions may be added in future updates.",
  },
  {
    question: "Is my data private and secure?",
    answer: (
      <>
        Absolutely. Your voice data is encrypted during processing and is never
        stored, sold, or shared. We follow strict privacy practices to ensure
        your personal information remains safe. For complete details, you can
        view our{" "}
        <a
          href="/privacy-policy"
          rel="noopener noreferrer"
          className="text-blue-600 underline hover:text-blue-800"
        >
          Privacy Policy
        </a>
        .
      </>
    ),
  },
  {
    question: "What happens if I reach my transcription limit?",
    answer:
      "If you're on the free plan, you receive 15 minutes of transcription time per week. Once this limit is reached, transcription will pause until the next weekly cycle resets. With the Pro plan, there are no limits and you get unlimited transcription minutes, ideal for frequent or professional use.",
  },
  {
    question: "Can I cancel or change my plan whenever I want?",
    answer:
      "Yes, you can cancel, upgrade, or downgrade at any time directly from your account dashboard. There are no contracts or cancellation fees. If you cancel, your access remains active until the end of your billing period, and you won’t be charged again.",
  },
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = (index) => {
    setOpenIndex(index === openIndex ? null : index);
  };
  const { ref: tagRef, inView: tagView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });

  const { ref: headingRef, inView: headingView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });
  const isMobile = useBreakpoint();

  const { ref: faqRef, inView: faqView } = useInView({
    triggerOnce: true,
    threshold: isMobile ? 0.2 : 0.5,
  });

  return (
    <>
      <div className=" flex flex-col gap-6 md:py-10 z-[5] ">
        <div
          ref={tagRef}
          className={`${
            tagView ? `animate-scaleIn anim-preserve` : "opacity-0"
          } flex justify-center py-4 px-8 bg-[#EBF7FE] rounded-full w-max mx-auto items-center text-[#3AB1F6] font-semibold font-inter text-[0.888rem]`}
        >
          Frequently Asked Questions
        </div>
        <div
          ref={headingRef}
          className={`${
            headingView
              ? `animate-slideUp anim-preserve z-[3]`
              : "opacity-0 z-0"
          } text-center text-black  leading-tight font-jakarta font-bold xl:text-[3.125rem] lg:text-[2.8rem] md:text-[2.4rem] text-[2.625rem] tracking-tighter`}
        >
          We're here to answer all your questions.
        </div>
        <div className="xl:text-[1.438rem] z-[4] relative bg-white lg:text-[1.2rem] md:text-[1.15rem] text-[1.313rem] font-inter font-medium text-center text-[#636363]">
          If you're new to Zero Typing or exploring ways to boost productivity
          with voice driven <br className="md:flex hidden" /> text creation,
          this section will help you understand the platform and its powerful{" "}
          <br className="md:flex hidden" /> features.
        </div>
        <div
          ref={faqRef}
          className={`max-w-2xl flex flex-col gap-4 mx-auto ${
            faqView ? `animate-slideUp anim-preserve z-[3]` : "opacity-0 z-0"
          }`}
        >
          {faqs.map((faq, index) => (
            <FAQItem
              key={index}
              question={faq.question}
              answer={faq.answer}
              isOpen={index === openIndex}
              onClick={() => handleToggle(index)}
            />
          ))}
        </div>
        <div className="flex flex-col gap-6 md:py-10 z-[4] relative bg-white w-full">
          <span className="  text-[#636363] md:text-[1.563rem] text-[1.313rem] font-inter font-medium text-center">
            Still have questions?
          </span>
          <button
            onClick={() => setIsOpen(true)}
            className="flex justify-center py-4 px-8 bg-[#EBF7FE] rounded-full w-max mx-auto items-center text-[#3AB1F6] font-semibold font-inter text-[1.125rem]"
          >
            Get in touch
          </button>
        </div>
      </div>
      <ContactUs isOpen={isOpen} setIsOpen={setIsOpen} />
    </>
  );
};

export default FAQ;
